import { createEffect, onMount } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { Text, View, hexColor } from "@lightningtv/solid";
import { isRTL } from "../../translations/configuration";
import { rtlX } from "../../utils/rtl";

const CARD_W = 250;

const SettingsPage = () => {
  let userInfoRef: any;
  let aboutAppRef: any;
  const navigate = useNavigate();

  // Use onMount so the ref is guaranteed to be assigned before focusing.
  onMount(() => {
    localStorage.setItem("@emptyCategory", "true");
    userInfoRef?.setFocus();
  });

  // LTR positions: userInfo at x=100, aboutApp at x=380.
  // In RTL they mirror: userInfo at x=1920-100-250=1570, aboutApp at x=1920-380-250=1290.
  const userInfoX = () => rtlX(100, CARD_W, isRTL());
  const aboutAppX = () => rtlX(380, CARD_W, isRTL());

  return (
    <View
      color={hexColor("#000000")}
      onEscape={() => navigate("/home")}
    >
      <View
        ref={(el) => { userInfoRef = el; }}
        x={userInfoX()}
        y={70}
        style={{
          width: CARD_W,
          height: 250,
          borderRadius: 15,
          color: hexColor("#222222"),
          focus: { color: hexColor("#128DD3") },
          transition: { scale: { duration: 250, easing: "ease-in-out" } },
        }}
        onRight={() => isRTL() ? null : aboutAppRef?.setFocus()}
        onLeft={() => isRTL() ? aboutAppRef?.setFocus() : null}
        onEnter={() => navigate("/userInfo")}
      >
        <View x={75} y={50} width={95} height={95} src="https://i.ibb.co/L89F97B/profileuser.png" />
        <Text x={75} y={170} style={{ fontSize: 22, color: hexColor("#ffffff") }}>
          User Info
        </Text>
      </View>

      <View
        ref={(el) => { aboutAppRef = el; }}
        x={aboutAppX()}
        y={70}
        style={{
          focus: { color: hexColor("#128DD3") },
          width: CARD_W,
          height: 250,
          borderRadius: 15,
          color: hexColor("#222222"),
          transition: { scale: { duration: 250, easing: "ease-in-out" } },
        }}
        onLeft={() => isRTL() ? null : userInfoRef?.setFocus()}
        onRight={() => isRTL() ? userInfoRef?.setFocus() : null}
        onEnter={() => navigate("/aboutApp")}
      >
        <View x={75} y={50} width={97} height={97} src="https://i.ibb.co/qdgwnkT/info.png" />
        <Text x={75} y={170} style={{ fontSize: 22, color: hexColor("#ffffff") }}>
          About App
        </Text>
      </View>
    </View>
  );
};

export default SettingsPage;
